export const defaultValues = {
  assetCode: '',
  networkName: '',
  cryptoAddress: '',
  templateName: '',
};
